__turbopack_context__.v({
  "hasLoading": "styles-module-scss-module__uOWvpq__hasLoading",
  "spinner": "styles-module-scss-module__uOWvpq__spinner",
});
